/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Pati Gmbh - Where software coems to life",
  description:"site.subtitle",
  og: {
    title: "Pati Gmbh",
    type: "website",
    url: "http://patigmbh.de/",
  },
};

//Home Page
const greeting = {
  title: "site.title",
  logo_name: "PaTi GmbH",
  nickname: "IT Consulting",
  subTitle:"site.subtitle",
  resumeLink:
    "https://TODO",
  portfolio_repository: "https://patigmbh.de",
  githubProfile: "https://patigmbh.de",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/pati-it",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/pati-it/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/pati-it",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:pati-it@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/pati-it",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/pati-it/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/pati-it/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "skill.fullstack",
      fileName: "FullStackImg",
      skills: [
        "skill.fullstack.info1",
        "skill.fullstack.info2",
        "skill.fullstack.info3",
        "skill.fullstack.info4",
        "skill.fullstack.info5",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "skill.cloud",
      fileName: "CloudInfraImg",
      skills: [
        "skill.cloud.info1",
        "skill.cloud.info2",
        "skill.cloud.info3",
        "skill.cloud.info4",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "skill.uxui",
      fileName: "DesignImg",
      skills: [
        "skill.uxui.info1",
        "skill.uxui.info2",
        "skill.uxui.info3",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    {
      title: "skill.datasceince",
      fileName: "DataScienceImg",
      skills: [
        "skill.datascience.info1",
        "skill.datascience.info2",
        "skill.datascience.info3",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
  ],
};


// Projects Page
const servicePageHeader = {
  title: "skill.fullstack",
  description: [
		"skill.fullstack.info1",
		"skill.fullstack.info2",
		"skill.fullstack.info3",
		"skill.fullstack.info4",
		"skill.fullstack.info5",
	],
  avatar_image_path: "projects_image.svg",
};
const serviceSkills = {
  data: [
    {
      title: "skill.datascience",
      fileName: "DataScienceImg",
      skills: [
        "skill.datascience.info1",
        "skill.datascience.info2",
        "skill.datascience.info3",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "skill.frontend",
      fileName: "FullStackImg",
      skills: [
				"skill.frontend.info1",
				"skill.frontend.info2",
				"skill.frontend.info3",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "devicon:css3-wordmark",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ES6",
          imageSrc: "es6.jpg",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "ExpressJS",
          imageSrc: "expressjs.png",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FD6C35",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "logos:gitlab",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Babel",
          fontAwesomeClassname: "skill-icons:babel",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "WebStorm",
          fontAwesomeClassname: "logos:webstorm",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "SourceTree",
          fontAwesomeClassname: "logos:sourcetree",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "logos:jira",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Confluence",
          fontAwesomeClassname: "logos:confluence",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "skill.backend",
      fileName: "FullStackImg",
      skills: [
        "skill.backend.info1",
        "skill.backend.info2",
        "skill.backend.info3",
        "skill.backend.info4",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "skill-icons:kafka",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "skill-icons:docker",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Gradle",
          fontAwesomeClassname: "simple-icons:gradle",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Hibernate",
          fontAwesomeClassname: "simple-icons:hibernate",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Google Cloud",
          fontAwesomeClassname: "devicon:googlecloud",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Eclipse",
          fontAwesomeClassname: "devicon:eclipse",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "Tomcat",
          fontAwesomeClassname: "logos:tomcat",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "logos:apache",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "devicon:rabbitmq",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Markdown",
          fontAwesomeClassname: "logos:markdown",
          style: {
            color: "#02569B",
          },
        },
        
        {
          skillName: "npm",
          fontAwesomeClassname: "logos:npm-icon",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kibana",
          fontAwesomeClassname: "logos:kibana",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Logstash",
          fontAwesomeClassname: "logos:logstash",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache Camel",
          fontAwesomeClassname: "logos:apache-camel",
          style: {
            color: "#02569B",
          },
        },
        {
					skillName: "XBRL",
					imageSrc: "XBRL.png",
				},
      ]
    },
  ],
};


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  servicePageHeader,
  serviceSkills,
};